(function () {
  var footer = document.querySelector('.tsg-ft');
  if (!footer) return;

  var desktop = window.matchMedia('(min-width: 768px)');
  function syncAccordions() {
    footer.querySelectorAll('.tsg-ft__acc').forEach(function (d) {
      if (desktop.matches) d.setAttribute('open', '');
      else d.removeAttribute('open');
    });
  }
  footer.querySelectorAll('.tsg-ft__acc > summary').forEach(function (s) {
    s.addEventListener('click', function (e) { if (desktop.matches) e.preventDefault(); });
  });
  syncAccordions();
  if (desktop.addEventListener) desktop.addEventListener('change', syncAccordions);

  // Newsletter: Klaviyo client subscriptions API. The list is single opt-in, so a
  // 202 means the welcome email is already queued; say that, not "confirm".
  var form = document.getElementById('tsg-ft-news-form');
  if (form && window.fetch) {
    var input = form.querySelector('.tsg-ft__input');
    var btn = form.querySelector('.tsg-ft__submit');
    var msg = form.querySelector('.tsg-ft__news-msg');
    var label = btn.textContent;
    var say = function (text, state) {
      msg.textContent = text;
      msg.setAttribute('data-state', state);
    };
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      var email = input.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        say('Enter a valid email address.', 'error');
        input.focus();
        return;
      }
      btn.disabled = true;
      btn.textContent = 'Sending...';
      say('', '');
      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + form.getAttribute('data-company'), {
        method: 'POST',
        headers: { 'content-type': 'application/vnd.api+json', revision: '2025-07-15' },
        body: JSON.stringify({ data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Footer',
            profile: { data: { type: 'profile', attributes: {
              email: email,
              subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
            } } }
          },
          relationships: { list: { data: { type: 'list', id: form.getAttribute('data-list') } } }
        } })
      }).then(function (r) {
        if (!r.ok) throw new Error('klaviyo ' + r.status);
        form.classList.add('tsg-ft__form--done');
        say("You're in. Your first email is on its way.", 'success');
      }).catch(function () {
        btn.disabled = false;
        btn.textContent = label;
        say("That didn't go through. Check the address and try again.", 'error');
      });
    });
  }
})();
